import { render, staticRenderFns } from "./ResourcePlanningReport.vue?vue&type=template&id=20faeaac&"
import script from "./ResourcePlanningReport.vue?vue&type=script&lang=js&"
export * from "./ResourcePlanningReport.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePlanningReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports